import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-apps',
  templateUrl: './manage-apps.page.html',
  styleUrls: ['./manage-apps.page.scss'],
})
export class ManageAppsPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
